// extracted by mini-css-extract-plugin
module.exports = {"successMsg":"H9ac5","successIcon":"H9adt","msg":"H9adv","closeButton":"H9adx"};